import { Link, useLocation } from "react-router-dom";

const Navbar = () => {
    const location = useLocation();
    const { pathname } = location;
    return (
        <>
            <nav className="bg-transparent">
                <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
                    <Link to={"/"}>
                        <a className="flex items-center space-x-3 rtl:space-x-reverse">
                            <img
                                src="https://static.vecteezy.com/system/resources/previews/027/623/630/original/blockchain-explorer-icon-vector.jpg"
                                className="h-8"
                                alt="Logo"
                            />
                            <span className="self-center text-2xl font-semibold whitespace-nowrap">
                                Block Explorer
                            </span>
                        </a>
                    </Link>
                    <button
                        data-collapse-toggle="navbar-default"
                        type="button"
                        className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
                        aria-controls="navbar-default"
                        aria-expanded="false"
                    >
                        <span className="sr-only">Open main menu</span>
                        <svg
                            className="w-5 h-5"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 17 14"
                        >
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M1 1h15M1 7h15M1 13h15"
                            />
                        </svg>
                    </button>
                    <div
                        className="hidden w-full md:block md:w-auto"
                        id="navbar-default"
                    >
                        <ul className="font-medium flex flex-col p-4 md:p-0 mt-4 border border-gray-100 rounded-lg md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0 md:border-0">
                            <Link to={"/"}>
                                <li>
                                    <a
                                        className={`block py-2 px-3 rounded ${
                                            pathname === "/"
                                                ? "text-blue-700"
                                                : "text-black"
                                        } md:bg-transparent md:p-0`}
                                        aria-current="page"
                                    >
                                        Home
                                    </a>
                                </li>
                            </Link>
                            {/* <Link to={"/send"}>
                                <li>
                                    <a
                                        className={`block py-2 px-3 rounded ${
                                            pathname === "/send"
                                                ? "text-blue-700"
                                                : "text-black"
                                        } md:bg-transparent md:p-0`}
                                        aria-current="page"
                                    >
                                        Send Transactions
                                    </a>
                                </li>
                            </Link> */}
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    );
};

export default Navbar;
